import Vue from "vue"
import Product from "./product.vue"

new Vue({
    render: h => h(Product)
}).$mount('#app')